import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Injectable } from '@angular/core';

import { C } from 'src/app/@shared/constants';
import { StorageService } from 'src/app/@core/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AppMigrationService {
  constructor(private storage: StorageService) {}

  public async init(): Promise<void> {
    const lastKnownVersion = this.storage.get('appVersion');
    const currentVersion = await this.getAppVersion();

    // first app start
    if (!lastKnownVersion) {
      this.storage.set('appVersion', currentVersion);

      return Promise.resolve();
    }

    // http://stackoverflow.com/questions/6832596/how-to-compare-software-version-number-using-js-only-number
    // a > b  returns number >= 1
    // a = b  returns number = 0
    // a < b  returns number <= -1
    const result = this.compareVersion(lastKnownVersion, currentVersion);

    if (result >= 0) {
      return Promise.resolve();
    }

    return this.checkForBreakingChanges(lastKnownVersion, currentVersion);
  }

  private async getAppVersion(): Promise<string> {
    if (!Capacitor.isNativePlatform()) {
      return Promise.resolve(C.APP_VERSION.number);
    }

    const info = await App.getInfo();

    return info.version;
  }

  private compareVersion(a: string, b: string): number {
    let diff; let
      i;
    const radix = 10;
    // eslint-disable-next-line require-unicode-regexp
    const regExStrip0 = /(\.0+)+$/;
    const segmentsA = a.replace(regExStrip0, '').split('.');
    const segmentsB = b.replace(regExStrip0, '').split('.');
    const l = Math.min(segmentsA.length, segmentsB.length);

    for (i = 0; i < l; i++) {
      diff = parseInt(segmentsA[i], radix) - parseInt(segmentsB[i], radix);
      if (diff) {
        return diff;
      }
    }

    return segmentsA.length - segmentsB.length;
  }

  private checkForBreakingChanges(lastKnownVersion: string, currentVersion: string): Promise<void> {
    console.info('check for breaking changes');
    console.info('last known app version', lastKnownVersion);
    console.info('current app version', currentVersion);

    // TODO: provide example code (e.g. if last known version < 1.0.0 -> log out)

    return Promise.resolve();
  }
}
